<template>
  <b-row>
    <b-col md="12">
      <card class="stacked-form">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <div class="row mb-5">
           <div class="col-md-3">
              <fg-input label="Kode">
                <p>{{model.code}}</p>
              </fg-input>
           </div>
           <div class="col-md-3">
              <fg-input label="Name">
                <p>{{model.name}}</p>
              </fg-input>
           </div>
           <div class="col-md-3">
              <fg-input label="Kategori">
                <p>{{model.category.category.name}}</p>
              </fg-input>
           </div>
        </div>
        <h3>Filter Berdasarkan:</h3>
        <b-row>
          <b-col md="6">
            <treeselect 
              v-model="filterBy.color"
              class="mb-3" 
              placeholder="Pilih warna" 
              :multiple="true"
              :clear-on-select="true"
              :options="colorList" 
              name="color"
            >
            </treeselect>
          </b-col>
          <b-col md="6">
            <treeselect 
              v-model="filterBy.size"
              class="mb-3" 
              placeholder="Pilih ukuran" 
              :multiple="true"
              :clear-on-select="true"
              :options="sizeList" 
              name="color"
            >
            </treeselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <label for="">Harga Beli</label>
            <input type="number" class="form-control" v-model="modelPrice.capital_price" min="0">
          </b-col>
          <b-col md="3">
            <label for="">Harga Jual</label>
            <input type="number" class="form-control" v-model="modelPrice.selling_price">
          </b-col>
          <b-col md="3">
            <label for="">Harga 3 - 11</label>
            <input type="number" class="form-control" v-model="modelPrice.more_3">
          </b-col>
          <b-col md="3">
            <label for="">Harga > 12</label>
            <input type="number" class="form-control" v-model="modelPrice.more_12">
          </b-col>
          <b-col md="3">
            <label for="">Harga Dropshipper</label>
            <input type="number" class="form-control" v-model="modelPrice.dropshipper">
          </b-col>
          <b-col md="3">
            <label for="">Harga Member</label>
            <input type="number" class="form-control" v-model="modelPrice.member_price">
          </b-col>
          <b-col md="3">
            <label for="">Harga Spesial Member</label>
            <input type="number" class="form-control" v-model="modelPrice.sm_price">
          </b-col>
          <b-col md="3">
            <label for="">Harga Gold Member</label>
            <input type="number" class="form-control" v-model="modelPrice.gold_member">
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col md="2">
            <b-button variant="primary" class="text-right" @click="doSubmit()"><font-awesome-icon icon="spinner" spin v-if="isLoading"/> <font-awesome-icon icon="save" v-else/> Terapkan</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col md="12" v-for="product in model.productColor" :key="product.id">
            <div class="table-responsive">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th rowspan="2">Warna</th>
                    <th rowspan="2">Ukuran</th>
                    <th colspan="8">Harga</th>
                  </tr>
                  <tr>
                    <th>Beli</th>
                    <th>Jual</th>
                    <th>Lebih 3</th>
                    <th>Lebih 12</th>
                    <th>Dropshipper</th>
                    <th>Member</th>
                    <th>Spesial Member</th>
                    <th>Gold Member</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="productSize in product.productSize" :key="productSize.id">
                    <td>{{product.colorName}}</td>
                    <td>{{productSize.size.name}}</td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.capital_price">
                      <span>{{formatNumber(productSize.capital_price)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.selling_price">
                      <span>{{formatNumber(productSize.selling_price)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.more_3">
                      <span>{{formatNumber(productSize.more_3)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.more_12">
                      <span>{{formatNumber(productSize.more_12)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.dropshipper">
                      <span>{{formatNumber(productSize.dropshipper)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.member_price">
                      <span>{{formatNumber(productSize.member_price)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.sm_price">
                      <span>{{formatNumber(productSize.sm_price)}}</span>
                    </td>
                    <td>
                      <input type="number" class="form-control" v-model="productSize.gold_member">
                      <span>{{formatNumber(productSize.gold_member)}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <!--<edit-button/>-->
        <back-button/>
      </card>
    </b-col>
  </b-row>
</template>

<script>
  import {Progress as LProgress} from 'src/components/index'
  import Edit from '@/components/Buttons/Edit'
  import Back from '@/components/Buttons/Back'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  export default {
    components: {
      LProgress,
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      EditButton: Edit,
      BackButton: Back,
      Treeselect
    },
    data () {
      return {
        apiUrl: {
          product: window.AppConfig.apiUrl + 'product',
          productChangePrice: window.AppConfig.apiUrl + 'product-change-price',
          color: window.AppConfig.apiUrl + 'color',
          size: window.AppConfig.apiUrl + 'size'
        },
        isLoading: false,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        sizeList: [],
        colorList: [],
        priceList: [
          { id: 'capital_price', label: 'Harga Beli' },
          { id: 'selling_price', label: 'Harga Jual' },
          { id: 'member_price', label: 'Harga Member' },
          { id: 'sm_price', label: 'Harga Spesial Member' },
          { id: 'more_3', label: 'Harga 3 - 11' },
          { id: 'more_12', label: 'Harga > 12' },
          { id: 'dropshipper', label: 'Harga Dropshipper' }
        ],
        modelPrice: {
          capital_price: 0,
          selling_price: 0,
          member_price: 0,
          sm_price: 0,
          more_3: 0,
          more_12: 0,
          dropshipper: 0,
          gold_member: 0
        },
        model: {
          code: null,
          name: null,
          category: {
            category: {
              name
            }
          },
          productColor: []
        },
        dataValue: null,
        filterBy: {
          color: [],
          size: []
        }
      }
    },
    watch: {
      'filterBy.color': function (val) {
        this.getDetailProduk()
      },
      'filterBy.size': function (val) {
        this.getDetailProduk()
      }
    },
    mounted () {
      this.getDetail()
      // this.getColor()
      this.getSize()
    },
    methods: {
      // getColor () {
      //   this.$http.get(this.apiUrl.color + '?limit=100').then(response => {
      //     this.colorList = []
      //     response.data.data.forEach(data => {
      //       this.colorList.push({
      //         id: data.id,
      //         label: data.name
      //       })
      //     })
      //   })
      // },
      getSize () {
        this.$http.get(this.apiUrl.size + '?limit=100').then(response => {
          this.sizeList = []
          response.data.data.forEach(data => {
            this.sizeList.push({
              id: data.id,
              label: data.name
            })
          })
        })
      },
      getDetail () {
        this.isLoading = true
        this.$http.get(this.apiUrl.product + '/' + this.$route.params.id)
        .then(response => {
          this.model.code = response.data.code
          this.model.name = response.data.name
          this.model.category = response.data.product_category
          this.colorList = []
          response.data.product_category.product_color.forEach(data => {
            this.colorList.push({
              id: data.color_id,
              label: data.color.name
            })
          })
          this.getDetailProduk()
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      getDetailProduk () {
        this.isLoading = true
        this.model.productColor = []
        let url = this.apiUrl.productChangePrice + '?product_id=' + this.$route.params.id
        if (this.filterBy.color.length > 0) {
          url += '&color_id=' + this.filterBy.color.toString()
        }
        if (this.filterBy.size.length > 0) {
          url += '&size_id=' + this.filterBy.size.toString()
        }
        this.$http.get(url)
        .then(response => {
          response.data.forEach(data => {
            let dataFilter = this.model.productColor.filter(dataFilter => dataFilter.colorId === data.product_color.color_id)
            if (this.model.productColor.length > 0 && dataFilter.length > 0) {
              this.model.productColor.filter((value, index, self) => {
                this.dataValue = value
                let th = this
                index === self.findIndex((t) => (
                  t.colorName === th.dataValue.colorName
                ))
              })
            } else {
              this.model.productColor.push({
                colorId: data.product_color.color_id,
                colorName: data.product_color.color.name,
                productSize: []
              })
            }
            // colorIds.push(data.product_color.color_id)
          })
          this.model.productColor.forEach(dataProduct => {
            response.data.forEach(dataResp => {
              if (dataProduct.colorId === dataResp.product_color.color_id) {
                dataProduct.productSize.push(dataResp)
              }
            })
          })
          // colorIds = [...new Set(colorIds)]
          // console.log(colorIds)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
          // this.$router.push('/notfound')
        })
      },
      doSubmit () {
        this.saveButtonData.isLoading = true
        this.$http.post(this.apiUrl.productChangePrice, {
          product_id: this.$route.params.id,
          filter_by: this.filterBy,
          model_price: this.modelPrice
        }).then(response => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/success', 'Warna berhasil di tambah.')
          this.addProduct = false
          this.getDetail()
        }).catch(error => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      formatNumber (num) {
        if (num !== null) {
          return 'Rp. ' + num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',-'
        } else {
          return 'Rp. ' + 0
        }
      }
    }
  }
</script>
<style scooped>
  .mt-4-5 {
    margin-top: 2rem !important;
  }
  .table-bordered thead th, .table-bordered thead td , .table-bordered tbody td, .table-bordered tbody span{
    vertical-align: middle;
    font-size: 12px;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Products/ChangePrice.vue